import React from 'react';
import ConfigPedidosConfirmados from '../components/Configuracion/ConfigPedidosConfirmados';

const ConfigPedidosConfirmadosPage = () => {
  return <ConfigPedidosConfirmados />;
};

export default ConfigPedidosConfirmadosPage;
